/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolCabinIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-cabin"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6 18.68L17.93 18.68Q17.93 18.68 17.93 18.68Q17.93 18.68 17.93 18.68L17.93 17.32L6 17.32L6 18.68Q6 18.68 6 18.68Q6 18.68 6 18.68ZM6 14.68L17.93 14.68L17.93 13.32L6 13.32ZM6.03 10.68L17.93 10.68L17.93 9.78L17.32 9.32L6.67 9.32L6.03 9.82ZM10.18 6.67L13.8 6.67L11.97 5.3Q11.97 5.3 11.97 5.3Q11.97 5.3 11.97 5.3ZM3.38 18.68L3.38 11.85L3.17 12Q2.75 12.35 2.2 12.28Q1.65 12.2 1.3 11.75Q0.97 11.32 1.05 10.79Q1.13 10.25 1.55 9.9L3.38 8.53L3.38 6.38Q3.38 5.83 3.76 5.44Q4.15 5.05 4.7 5.05Q5.25 5.05 5.64 5.44Q6.03 5.83 6.03 6.38L6.03 6.5L10.38 3.2Q11.1 2.65 11.97 2.64Q12.85 2.63 13.57 3.17L22.43 9.85Q22.85 10.2 22.94 10.74Q23.02 11.28 22.68 11.72Q22.32 12.15 21.79 12.24Q21.25 12.32 20.82 11.97L20.57 11.8L20.57 18.68Q20.57 19.8 19.81 20.56Q19.05 21.32 17.93 21.32L6.03 21.32Q4.9 21.32 4.14 20.56Q3.38 19.8 3.38 18.68ZM4.92 4.05Q4.22 4.05 3.85 3.46Q3.48 2.88 3.8 2.25Q4.3 1.23 5.26 0.64Q6.22 0.05 7.35 0.05Q7.65 0.05 7.91 -0.07Q8.18 -0.2 8.38 -0.42Q8.65 -0.78 9.03 -1.02Q9.4 -1.27 9.85 -1.27Q10.53 -1.27 10.88 -0.68Q11.22 -0.07 10.9 0.55Q10.38 1.55 9.43 2.14Q8.47 2.73 7.35 2.73Q7.08 2.73 6.81 2.86Q6.55 3 6.35 3.2Q6.08 3.55 5.71 3.8Q5.35 4.05 4.92 4.05Z" fill={color} />
    </svg>
  );
}
